/* Copyright (c) 2023 Xperi. All Rights Reserved. */

/* eslint-disable func-names */
import { ITransport, ServiceApiLogs } from '@tivocorp/tivo-webapp-loggers';
import { HttpRequestResponse } from './HttpRequestResponse';

export class NetworkInterceptor {
    private static TAG = 'NetworkInterceptor';

    private static isNetworkLoggingEnabled = false;

    static upload = (transport: ITransport) => {
        ServiceApiLogs.upload(transport);
    };

    static blacklistedUrls = [
        // TODO: Need to verify from sls if the url of sage gets changed.
        'https://sage-hec.oi.tivo.com:8088/services/collector/event',
        'https://api.segment.io/v1/batch',
    ];

    public static logging = (enable: boolean) => {
        NetworkInterceptor.isNetworkLoggingEnabled = enable;
        NetworkInterceptor.start();
    };

    static start = () => {
        if (!NetworkInterceptor.isNetworkLoggingEnabled) return;

        const { open, send, setRequestHeader } = XMLHttpRequest.prototype;
        Object.defineProperty(XMLHttpRequest.prototype, 'httpReqRes', {
            value: null,
            writable: true,
            enumerable: true,
            configurable: true,
        });

        // Get the Request Method and URL
        XMLHttpRequest.prototype.open = function (...args) {
            (this as any).httpReqRes = new HttpRequestResponse();
            (this as any).httpReqRes.setMethod(args[0]);
            (this as any).httpReqRes.setUrl(args[1]);
            open.apply(this, [args[0], args[1], args[2]]);
        };

        // Get the headers
        XMLHttpRequest.prototype.setRequestHeader = function (header, value) {
            setRequestHeader.apply(this, [header, value]);
            (this as any).httpReqRes.setHeaders(header, value);
        };

        // Send the request and get the response
        XMLHttpRequest.prototype.send = function (...args) {
            (this as any).httpReqRes.setBody(args);
            send.call(this, ...args);

            this.onreadystatechange = () => {
                if (this.readyState === XMLHttpRequest.DONE) {
                    (this as any).httpReqRes.setResponseText(this.response);

                    if (
                        NetworkInterceptor.isNetworkLoggingEnabled &&
                        !NetworkInterceptor.blacklistedUrls.includes(
                            (this as any).httpReqRes.mUrl,
                        ) &&
                        !NetworkInterceptor.blacklistedUrls.includes(this.responseURL)
                    ) {
                        ServiceApiLogs.addEventToQueue(
                            NetworkInterceptor.TAG,
                            (this as any).httpReqRes.toString(),
                        );
                    }
                }
            };
        };
    };
}
